const initialState = {
    
};

export const configAction = {

}
